<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10" v-if="route == 'create'">
          <revoke-consent-request-form-component :route="route" :csrf_token="csrf_token" :errors="errors" :existingData="existingData" :cancelUrl="cancelUrl"></revoke-consent-request-form-component>
        </div>
        <div class="col-md-10" v-if="route == 'index'">
          <revoke-consent-request-list-component :route="route" :permissions="permissions" :revokeConsentRequests="revokeConsentRequests"></revoke-consent-request-list-component>
        </div>
        <div class="col-md-10" v-if="route == 'show'">
          <revoke-consent-request-data-component :route="route" :csrf_token="csrf_token" :userId="userId" :userDisplayName="userDisplayName" :userEmail="userEmail" :numResources="numResources" :numIrrOwner="numIrrOwner" :permissions="permissions" :revokeConsentRequest="revokeConsentRequest"></revoke-consent-request-data-component>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        permissions: Object,
        errors: Array,
        existingData: [Object, Array],
        revokeConsentRequests: [Object, Array], //multiple Revoke Consent Requests
        revokeConsentRequest: [Object, Array],  //single Revoke Consent Request
        userDisplayName: String,
        userEmail: String,
        userId: String,
        numResources: String,
        numIrrOwner: String,
        cancelUrl: String,
      },
      data: function() {
        return {
          baseUrls: {
            resourceBaseUrl: '/resource/',
            userBaseUrl: '/user/'
          },
          csrf_token: $('meta[name="csrf-token"]').attr('content'),
        }
      },
      mounted(){
        //
      }
    }
</script>
